<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vx-card>
      <ValidationObserver v-slot="{ handleSubmit }" ref="form">
        <form @submit.prevent="handleSubmit">
          <div class="vx-row flex">
            <div class="vx-col w-1/2 mt-5">
              <validation-provider :name="$t('sections.master.dataForm.faculty')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.faculty") }}*</label>
                <v-select v-model="form.faculty" :clearable="true" :options="facultiesOptions" :reduce="res => res.value" name="faculty" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex">
            <div class="vx-col w-1/6  mt-5">
              <validation-provider :name="$t('sections.master.dataForm.curriculumNo')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.curriculumNo") }}*</label>
                <vs-input type="text" v-model="form.curriculumNo" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.master.dataForm.nameTh')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.nameTh") }}*</label>
                <vs-input type="text" v-model="form.nameTh" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.master.dataForm.nameEn')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.nameEn") }}</label>
                <vs-input type="text" v-model="form.nameEn" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/6 mt-5">
              <validation-provider :name="$t('sections.master.dataForm.status')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.status") }}*</label>
                <v-select v-model="form.status" :clearable="false" :options="statusesOptions" name="status" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex">
            <div class="vx-col w-1/3 mt-5">
              <validation-provider :name="$t('sections.master.dataForm.loanType')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.loanType") }}*</label>
                <v-select v-model="form.curriculumDetails.loanType" :clearable="true" :options="loanTypesOptions" :reduce="res => res.value" name="loanType" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/6 mt-5">
              <validation-provider :name="$t('sections.master.dataForm.curriculumPeriod')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.curriculumPeriod") }}*</label>
                <v-select v-model="form.curriculumDetails.curriculumPeriod" :clearable="true" :options="curriculumPeriodsOptions" :reduce="res => res.value" name="curriculumPeriod" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/6 mt-5">
              <validation-provider :name="$t('sections.master.dataForm.maximumLoanAmount')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.maximumLoanAmount") }}*</label>
                <vs-input type="number" v-model="form.curriculumDetails.maximumLoanAmount" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/6 mt-5">
              <validation-provider :name="$t('sections.master.dataForm.contractPeriod')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.contractPeriod") }}*</label>
                <v-select v-model="form.curriculumDetails.contractPeriod" :clearable="true" :options="contractPeriodsOptions" :reduce="res => res.value" name="contractPeriod" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/6 mt-5">
              <validation-provider :name="$t('sections.master.dataForm.paymentAmount')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.paymentAmount") }}*</label>
                <vs-input type="number" v-model="form.curriculumDetails.paymentAmount" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <!-- Save & Reset Button -->
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-8 flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto mt-2" @click="submit">{{ $t("sections.master.dataForm.action.btnSave") }}</vs-button>
                <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset">{{ $t("sections.master.dataForm.action.btnReset") }}</vs-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </div>
</template>


<script>
import vSelect from 'vue-select'
import { ValidationProvider } from 'vee-validate'
import { createNamespacedHelpers, mapGetters } from 'vuex'

const {mapActions: mapMasterActions, mapState: mapMasterFields } = createNamespacedHelpers('Master')

export default {
  components: {
    vSelect,
    ValidationProvider
  },

  data () {
    return {
      form:{
        faculty: '',
        curriculumNo: '',
        nameTh: '',
        nameEn: '',
        status: 'Enabled',
        curriculumDetails: {
          loanType: 'Principle',
          curriculumPeriod: 0,
          maximumLoanAmount: 0,
          contractPeriod: 0,
          paymentAmount: 0
        }
      }
    }
  },
  async created () {
    const vm = this
    await vm.getFaculties()
    await vm.getCurriculum({form: {id: vm.$route.params.id}})
    vm.pms ('MasterCurriculum', 'edit', 'r')
    vm.reset ()
  },
  computed: {
    ...mapMasterFields(['status', 'curriculum']),
    ...mapGetters({
      statusesOptions :'Master/statusesOptions',
      facultiesOptions :'Master/facultiesOptions',
      loanTypesOptions :'Master/loanTypesOptions',
      curriculumPeriodsOptions :'Master/curriculumPeriodsOptions',
      contractPeriodsOptions :'Master/contractPeriodsOptions'
    })
  },
  methods: {
    ...mapMasterActions(['getFaculties', 'getCurriculum', 'updateCurriculum']),
    async submit () {
      const vm = this
      vm.$refs['form'].validate().then(success => {
        if (!success) {
          return
        }

        this.updateCurriculum({
          id: vm.$route.params.id,
          form: {
            faculty:  {id: vm.form.faculty || ''},
            curriculumNo: vm.form.curriculumNo,
            nameTh: vm.form.nameTh,
            nameEn: vm.form.nameEn,
            status: vm.form.status,
            curriculumDetails: {
              loanType: vm.form.curriculumDetails.loanType || '',
              curriculumPeriod: parseInt(vm.form.curriculumDetails.curriculumPeriod) || 0,
              maximumLoanAmount: parseFloat(vm.form.curriculumDetails.maximumLoanAmount) || 0,
              contractPeriod: parseInt(vm.form.curriculumDetails.contractPeriod) || 0,
              paymentAmount: parseFloat(vm.form.curriculumDetails.paymentAmount) || 0
            },
          },
          vm,
          redirect: "/master/curriculum"
        })
      })
    },
    reset () {
      const vm = this
      // console.log(vm.curriculum.curriculumDetails);
      const curriculumDetail = vm.curriculum.curriculumDetails.filter(res => res.status === "Enabled")

      const faculty = (vm.curriculum.faculty ? vm.curriculum.faculty.id : '')

      vm.form = {
        faculty,
        curriculumNo: vm.curriculum.curriculumNo,
        nameTh: vm.curriculum.nameTh,
        nameEn: vm.curriculum.nameEn,
        status: vm.form.status,
        curriculumDetails: {
          loanType: (curriculumDetail.length !== 0 ? curriculumDetail[0].loanType : ''),
          curriculumPeriod: (curriculumDetail.length !== 0  ? curriculumDetail[0].curriculumPeriod : 0),
          maximumLoanAmount: (curriculumDetail.length !== 0  ? curriculumDetail[0].maximumLoanAmount : 0),
          contractPeriod: (curriculumDetail.length !== 0  ? curriculumDetail[0].contractPeriod : 0),
          paymentAmount: (curriculumDetail.length !== 0  ? curriculumDetail[0].paymentAmount : 0)
        },
      }
    }
  },
  watch: {
      status: {
        handler(res) {
          if (res.processing !== null) {
            if (res.processing) {
              this.$vs.loading();
            } else {
              this.$vs.loading.close();
            }
          }
          if (res.success !== null) {
            this.$vs.notify({...res.success})
          } else if (res.error !== null) {
            this.$vs.notify({...res.error})
          }
        },
        deep: true
      },
  }
}
</script>
